module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', [_vm._v("\n    Enter the MQTT credentials.\n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendDone($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "mqtt_broker_address"
    }
  }, [_vm._v("MQTT broker address")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.host),
      expression: "host",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "id": "mqtt_broker_address",
      "placeholder": "IP or hostname",
      "pattern": "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\\-]*[A-Za-z0-9])$",
      "required": ""
    },
    domProps: {
      "value": (_vm.host)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.host = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "mqtt_broker_port"
    }
  }, [_vm._v("MQTT broker port")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.port),
      expression: "port",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "1",
      "min": "1",
      "max": "65535",
      "id": "mqtt_broker_port",
      "placeholder": "Port number",
      "required": ""
    },
    domProps: {
      "value": (_vm.port)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.port = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "homie_base_topic"
    }
  }, [_vm._v("Homie base topic")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.baseTopic),
      expression: "baseTopic",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "id": "homie_base_topic",
      "placeholder": "Base topic"
    },
    domProps: {
      "value": (_vm.baseTopic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.baseTopic = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth),
      expression: "auth"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.auth) ? _vm._i(_vm.auth, null) > -1 : (_vm.auth)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.auth,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.auth = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.auth = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.auth = $$c
        }
      }
    }
  }), _vm._v(" Use MQTT authentication\n      ")])]), _vm._v(" "), (_vm.auth) ? _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "mqtt_username"
    }
  }, [_vm._v("MQTT username")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "id": "mqtt_username",
      "placeholder": "Username",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "mqtt_password"
    }
  }, [_vm._v("MQTT password")]), _vm._v(" "), _c('p', {
    staticClass: "control is-grouped"
  }, [(_vm.passwordClearText) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "autocapitalize": "none",
      "id": "mqtt_password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "id": "mqtt_password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordClearText),
      expression: "passwordClearText"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.passwordClearText) ? _vm._i(_vm.passwordClearText, null) > -1 : (_vm.passwordClearText)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.passwordClearText,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.passwordClearText = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.passwordClearText = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.passwordClearText = $$c
        }
      }
    }
  }), _vm._v(" Show password\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsValid
    }
  }, [_vm._v("Next")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help"
  }, [_vm._v("Optional. The default value is "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("homie/")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6525ff74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Mqtt.vue
// module id = 57
// module chunks = 0